import * as React from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import type { GenericList } from './models/JobSharedInterfaces';
import { GetQuery } from './Shared';
import type { NewManualItem } from './models/JobScheduleInterfaces';

interface ScheduleNewManualJobProps {
    newItem: NewManualItem;
    scheduleTypes: GenericList[]
    updateData(newItem: NewManualItem): void;
}

interface ScheduleNewManualJob {
    jobIdSearch: string;
    siteAddressSearch: string;
    showResults: boolean;
    results: JobSearchResults[];
    loading: boolean;
}

interface JobSearchResults {
    id: number;
    customer: string;
    siteAddress: string;
    finalQuoteNumber: string;
    status: string;
}

export default class ScheduleNewManualJobData extends React.Component<ScheduleNewManualJobProps, ScheduleNewManualJob> {
    constructor(props: ScheduleNewManualJobProps) {
        super(props);
        this.state = {
            jobIdSearch: "",
            siteAddressSearch: "",
            results: [],
            showResults: false,
            loading: false
        }
    }

    search = (e: any) => {
        e.preventDefault();

        //check to make sure at least one search field has been entered
        if (this.state.jobIdSearch || this.state.siteAddressSearch) {
            this.searchJobs();
        } else {
            this.setState({ showResults: false });
            toast.error("Please enter at least one search item");
        }

    }

    searchJobs = async () => {
        const apiUrl = 'SearchJobs?JobId=' + this.state.jobIdSearch + '&CustomerId=&QuoteNo=&SiteAddress=' + encodeURIComponent(this.state.siteAddressSearch) + '&Suburb=&SiteVisit=&StatusId=-1&ShowCancelledJobs=false';
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            this.setState({ showResults: true, results: result.data });
        }
    }

    selectJob = (jobId: number, siteAddress: string, customer: string) => {
        var errors = this.props.newItem.errors;
        delete errors["jobId"];

        //load new invoice based on job selected
        this.setState({ jobIdSearch: "", siteAddressSearch: "", showResults: false, results: [] });

        let item = this.props.newItem;
        item.jobId = jobId;
        item.siteAddress = siteAddress;
        item.customerName = customer;
        item.errors = errors;
        this.props.updateData(item);
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);

    }

    handlePropsChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.props.newItem.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let newItem: any = this.props.newItem;
        newItem[e.target.name] = e.target.value;
        newItem.errors = errors;

        //update errors
        let change: any = {};
        this.setState(change);

        this.props.updateData(newItem);
    }

    handlePropsNumberChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.props.newItem.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let newItem: any = this.props.newItem;
        newItem[e.target.name] = Number(e.target.value);
        newItem.errors = errors;

        //update errors
        let change: any = {};
        this.setState(change);

        this.props.updateData(newItem);
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let newItem = this.props.newItem;
        let scheduleTypes = this.props.scheduleTypes;

        return (
           <div>
                <div className="makeitflex">
                    <label className="input-group--inline" htmlFor="jobIdSearch">
                        <span className="label">Job Id</span>
                        <input className="input allocatenewJobId" type="text" id="jobIdSearch" name="jobIdSearch" value={this.state.jobIdSearch} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <label className="input-group--inline" htmlFor="siteAddressSearch">
                        <span className="label label--setsizesm">Site Address</span>
                        <input className="input allocateSiteAddress" type="text" id="siteAddressSearch" name="siteAddressSearch" value={this.state.siteAddressSearch} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <button className="defaultbutton allocate__searchMargin" type='button' onClick={this.search}>Search</button>
                </div>
                <div className={this.state.showResults ? "" : "hidden"}>
                    <div className={this.state.results.length > 0 ? 'overflowAuto' : 'hidden'}>
                        <table className='table tableColours'>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Job Id</th>
                                    <th>Site Address</th>
                                    <th>Customer</th>
                                    <th>Quote Number</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.results.map(job =>
                                    <tr key={job.id}>
                                        <td><input type='checkbox' className="input" checked={false} onChange={() => this.selectJob(job.id, job.siteAddress, job.customer)} /></td>
                                        <td>{job.id}</td>
                                        <td>{job.siteAddress}</td>
                                        <td>{job.customer}</td>
                                        <td>{job.finalQuoteNumber}</td>
                                        <td>{job.status}</td>
                                        <td>
                                            <Link to={'/job/' + job.id + '/details'} target="_blank" >
                                                Open
                                            </Link>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <span className={this.state.results.length == 0 ? "" : "hidden"}>There were no matching jobs found. Try modifying your search criteria.</span>
                </div>
                <div className="row">
                    <hr></hr>
                </div>
                <label className="input-group" htmlFor="jobId">
                    <span className="label">Job Id</span>
                    <input type='text' id="jobId" name="jobId" className='input allocate__size100' value={newItem.jobId} onChange={(e) => this.handlePropsNumberChange(e)} disabled></input>
                </label>
                <span className="label errors">{this.props.newItem.errors["jobId"]}</span>
                <label className="input-group" htmlFor="siteAddress">
                    <span className="label">Site Address</span>
                    <input type='text' id="siteAddress" name="siteAddress" className='input' value={newItem.siteAddress} onChange={(e) => this.handlePropsChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="customerName">
                    <span className="label">Customer</span>
                    <input type='text' id="customerName" name="customerName" className='input' value={newItem.customerName} onChange={(e) => this.handlePropsChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="contactName">
                    <span className="label">Contact Name / Phone</span>
                    <input type='text' id="contactName" name="contactName" className='input' value={newItem.contactName} onChange={(e) => this.handlePropsChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="description">
                    <span className="label">Description</span>
                    <input type='text' id="description" name="description" className='input' value={newItem.description} onChange={(e) => this.handlePropsChange(e)}></input>
                </label>
                <span className="label errors">{this.props.newItem.errors["description"]}</span>
                <label className="input-group" htmlFor="typeId">
                    <span className="label">Type</span>
                    <select className="select" id="typeId" name="typeId" value={newItem.typeId} onChange={(e) => this.handlePropsNumberChange(e)}>
                        <option hidden defaultValue="-1"></option>
                        {scheduleTypes.map(type =>
                            <option key={type.id} value={type.id}>{type.name}</option>
                        )};
                    </select>
                </label>
                <span className="label errors">{this.props.newItem.errors["typeId"]}</span>
                <label className="input-group" htmlFor="notes">
                    <span className="label">Schedule Notes</span>
                    <textarea className="input allocate__teamnotes notesSize" id="notes" name="notes" value={newItem.notes} onChange={(e) => this.handlePropsChange(e)}></textarea>
                </label>
                <label className="input-group" htmlFor="runsheetNotes">
                    <span className="label">Runsheet Notes</span>
                    <textarea className="input allocate__teamnotes notesSize marginTop10" id="runsheetNotes" name="runsheetNotes" value={newItem.runsheetNotes} onChange={(e) => this.handlePropsChange(e)}></textarea>
                </label>
                    
            </div>
        );
    }



}